/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';

import type { JSX } from '@ovhcloud/ods-stencil/components/chip/custom-elements';

import { defineCustomElement as defineOsdsChip } from '@ovhcloud/ods-stencil/components/chip/custom-elements/osds-chip.js';

export const OsdsChip = /*@__PURE__*/createReactComponent<JSX.OsdsChip, HTMLOsdsChipElement>('osds-chip', undefined, undefined, defineOsdsChip);
